module.exports = __webpack_public_path__ + "img/register-v2-dark.29532cbe.svg";